import { AbstractControl, FormControl } from '@angular/forms';

export function descriptionFormDropdownCustomValidator(control: AbstractControl): { [key: string]: boolean } | null {

  if (control.value === 'default') {
    return { 'default': true };
  }
  return null;
}

export function descriptionFormOdometerCustomValidator(control: AbstractControl): { [key: string]: boolean } | null {

  if (control.value <= 0) {
    return { '0': true };
  }
  return null;
}
